import { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

// PLACEHOLDER — replace their actual vision statement wording via Admin Settings.

const DEFAULT_STATEMENT =
  "IASC Consultancy exists to make international education and career mobility accessible to every ambitious student and professional — connecting you to global opportunities with transparent guidance, every step of the way.";

export default function VisionStatement() {
  const [statement, setStatement] = useState(DEFAULT_STATEMENT);

  useEffect(() => {
    fetch(`${API_BASE}/settings/public`)
      .then((r) => r.json())
      .then((json) => {
        if (json.success && json.data.vision_statement) setStatement(json.data.vision_statement);
      })
      .catch(() => {});
  }, []);

  return (
    <section className="py-20 bg-white border-y border-[#e2e8f0]">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <span className="material-symbols-outlined text-[#ff7b7b] text-4xl mb-4 inline-block">flag</span>
        <p className="text-xl md:text-2xl text-[#0f172a] font-medium leading-relaxed">{statement}</p>
      </div>
    </section>
  );
}